"use strict";

(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.menu = {
    attach: function attach(context, settings) {
      var bodyElement = $('body');
      $('.toggle--link', context).on('click', function (e) {
        bodyElement.toggleClass('sidebar-open');
        e.stopPropagation();
        $(document, context).on('click', function (e) {
          if (!$(e.target).parents('#sidebar').length && bodyElement.hasClass('sidebar-open')) {
            $('body').removeClass('sidebar-open');
          }
        });
      });
    }
  };
})(jQuery, Drupal);